import { Injectable, inject, Signal } from '@angular/core';
import { AuthState } from '../../states/auth.state';
import { UserEntity } from '../../../domain/entities/user.entity';

/**
 * Get User Use Case
 *
 * Retrieves the currently authenticated user from auth state.
 * Returns a signal that provides reactive access to user data.
 *
 * Use this when you need:
 * - Access to current user information (id, email, name, role)
 * - Reactive updates when user changes
 * - Read-only user data
 *
 * @returns Signal containing the current user or null if not authenticated
 */
@Injectable({ providedIn: 'root' })
export class GetUserUseCase {
  private readonly _authState = inject(AuthState);

  /**
   * Execute the use case
   * @returns Signal with current user or null
   */
  public execute(): Signal<UserEntity | null> {
    return this._authState.user;
  }
}
